// src/design/tokens.js

export const colors = {
  // surfaces
  background: "#EEF4F5",
  surface: "#FFFFFF",
  surfaceSoft: "#F8FBFB",

  // brand
  primary: "#B7D3DB",
  primaryDark: "#8FAFB8",

  secondary: "#EEDDD7",

  // text
  text: "#1F2529",
  textMuted: "#7B8790",
  textWhite: "#fff",

  // ui
  border: "rgba(0,0,0,0.06)",
  overlay: "rgba(0,0,0,0.3)",

  // states
  success: "#B7DDBF",
  warning: "#F2D6A2",
  danger: "#E4B8B8",

  error: "rgb(255,0,0)",
};

export const space = {
  xs: "4px",
  sm: "8px",
  md: "12px",
  lg: "16px",
  xl: "24px",
  xxl: "32px",
  xxxl: "48px",
};

export const radius = {
  xs: "4px",
  sm: "8px",
  md: "12px",
  lg: "16px",
  xl: "24px",
  round: "999px",
};

export const fontSize = {
  xs: "12px",
  sm: "14px",
  md: "16px",
  lg: "20px",
  xl: "28px",
  xxl: "36px",
};

export const fontWeight = {
  regular: 400,
  medium: 500,
  semibold: 600,
  bold: 700,
};

export const shadows = {
  sm: "0 1px 3px rgba(0,0,0,0.04)",
  md: "0 4px 12px rgba(0,0,0,0.06)",
  lg: "0 10px 30px rgba(0,0,0,0.08)",
};

export const borders = {
  sm: "1px solid",
  md: "2px solid",
  lg: "4px solid",
};

export const zIndex = {
  header: 100,
  drawer: 200,
  modal: 300,
  toast: 400,
};

export const layout = {
  maxWidth: "720px",
  headerHeight: "56px",
  bottomBarHeight: "72px",
};

const tokens = {
  colors,
  space,
  radius,
  fontSize,
  fontWeight,
  shadows,
  borders,
  zIndex,
  layout,
};

export default tokens;